import { render, staticRenderFns } from "./GoToTopButton.vue?vue&type=template&id=6dc2fae6&scoped=true&"
import script from "./GoToTopButton.vue?vue&type=script&lang=js&"
export * from "./GoToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./GoToTopButton.vue?vue&type=style&index=0&id=6dc2fae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2fae6",
  null
  
)

export default component.exports